import { Alert, AlertDescription, chakra } from '@chakra-ui/react';
import React from 'react';

interface Props {
  className?: string;
  message?: React.ReactNode;
}

const DataFetchAlert = ({ className, message }: Props) => {
  return (
    <Alert status="warning" width="fit-content" className={ className }>
      <AlertDescription>
        { message ?? 'Something went wrong. Try refreshing the page or come back later.' }
      </AlertDescription>
    </Alert>
  );
};

export default chakra(DataFetchAlert);
